import { createContext, Dispatch, ReactElement, SetStateAction } from 'react';

import ModelInitialState from '../data/ModelInitialState.json';
import { InitDataObjectProps, InitDataQuestionnaireObjectProps } from '../types/initData';
import { GlobalErrorProps, InsuranceType, MultiAnswerProps } from '../types/common';
import { ModelProps } from '../types/model';

export interface FormStepProps {
    current: number;
    completed: number;
}

export interface PopupContentVariablesProps {
    [key: string]: boolean | number | string;
}

export interface ContextProps {
    isInsurable: boolean;
    setIsInsurable: (value: boolean) => void;
    popupVisible: boolean;
    setPopupVisible: (visible: boolean) => void;
    closeButton: boolean;
    setCloseButton: (visible: boolean) => void;
    popupContent: null | ReactElement;
    setPopupContent: (content: ReactElement) => void;
    popupContentVariables: PopupContentVariablesProps | null;
    setPopupContentVariables: (contentVariables: PopupContentVariablesProps | null) => void;
    initData: InitDataObjectProps | null;
    setInitData: (data: InitDataObjectProps) => void;
    initDataQuestionaire: InitDataQuestionnaireObjectProps | null;
    setInitDataQuestionaire: (data: InitDataQuestionnaireObjectProps) => void;
    insuranceType: InsuranceType;
    setInsuranceType: (insuranceType: InsuranceType) => void;
    formResult: ModelProps;
    setFormResult: Dispatch<SetStateAction<ModelProps>>;
    diseaseCount: number;
    setDiseaseCount: (data: number) => void;
    formStep: FormStepProps;
    setFormStep: (data: FormStepProps) => void;
    multiAnswer: MultiAnswerProps;
    setMultiAnswer: (data: MultiAnswerProps) => void;
    globalError: Array<GlobalErrorProps>;
    setGlobalError: (data: Array<GlobalErrorProps>) => void;
    popupCloseEvent: string | null;
    setPopupCloseEvent: (data: string | null) => void;
    popupCloseCallback: () => void;
    setPopupCloseCallback: (callback: () => void) => void;
    isBackButtonVisible: boolean;
    setIsBackButtonVisible: (visible: boolean) => void;
    navigationLocked: boolean;
    setNavigationLocked: (value: boolean) => void;
    showBlockPopup: boolean;
    setShowBlockPopup: (value: boolean) => void;
    isSaving: boolean;
    setIsSaving: (value: boolean) => void;
    previouslyFocusedElementRef: React.MutableRefObject<HTMLElement | null>;
}

export const AppContext = createContext<ContextProps>({
    isInsurable: true,
    setIsInsurable: () => true,
    popupVisible: false,
    setPopupVisible: () => false,
    closeButton: false,
    setCloseButton: () => false,
    popupContent: null,
    setPopupContent: () => false,
    popupContentVariables: null,
    setPopupContentVariables: () => false,
    initData: null,
    setInitData: () => false,
    initDataQuestionaire: null,
    setInitDataQuestionaire: () => false,
    insuranceType: null,
    setInsuranceType: () => false,
    formResult: ModelInitialState,
    setFormResult: () => ModelInitialState,
    diseaseCount: 0,
    setDiseaseCount: () => null,
    formStep: { current: 0, completed: -1 },
    setFormStep: () => null,
    multiAnswer: {},
    setMultiAnswer: () => null,
    globalError: [],
    setGlobalError: () => null,
    popupCloseEvent: '',
    setPopupCloseEvent: () => null,
    popupCloseCallback: () => null,
    setPopupCloseCallback: () => () => null,
    isBackButtonVisible: false,
    setIsBackButtonVisible: () => false,
    navigationLocked: false,
    setNavigationLocked: () => false,
    showBlockPopup: false,
    setShowBlockPopup: () => false,
    isSaving: false,
    setIsSaving: () => false,
    previouslyFocusedElementRef: { current: null },
});
